import React from 'react';
import { Wrapper } from './PageBox.styles';

export type PageBoxProps = {
	children: React.ReactNode;
	margin?: string;
	minHeigth?: string;
	height?: string;
};

export const PageBox = ({
	children,
	margin,
	minHeigth = '70vh',
	height,
}: PageBoxProps): JSX.Element => (
	<Wrapper margin={margin} minHeigth={minHeigth} height={height}>
		{children}
	</Wrapper>
);
